export default function makeLinkedTree(
  entities,
  {
    getNodeId = entity => entity.id,
    getNodeParentId = entity => entity.parentId,
  } = {},
  isRootOnly = false,
) {
  const nodes = entities.reduce((map, entity) => {
    const id = getNodeId(entity);
    map.set(id, {
      id,
      entity,
      depth: 0,
      orphan: false,
      parent: null,
      children: [],
    });
    return map;
  }, new Map());

  addRelations(nodes, { getNodeId, getNodeParentId });
  addDepth(nodes);

  const result = Array.from(nodes.values());

  return isRootOnly ? result.filter(node => !node.parent) : result;
}

function addRelations(nodes, { getNodeParentId }) {
  for (const node of nodes.values()) {
    const parentId = getNodeParentId(node.entity);
    if (!parentId) {
      continue;
    }

    const parentNode = nodes.get(parentId);
    if (!parentNode) {
      node.orphan = true;
      continue;
    }

    node.parent = parentNode;
    parentNode.children.push(node);
  }
}

function addDepth(nodes) {
  addDepthRec(
    Array.from(nodes.values()).filter(node => !node.parent),
    0,
  );
}

function addDepthRec(nodes, depth) {
  for (const node of nodes) {
    node.depth = depth;
    addDepthRec(node.children, depth + 1);
  }
}
